import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Endpoint, UnitType } from 'app/app.type';
import { SharedService } from 'app/shared/shared.service';
import { KeycloakService } from 'keycloak-angular';
import { take } from 'rxjs';

@Component({
    selector: 'unit-selection-dialog',
    templateUrl: './unit-selection-dialog.component.html',
})
export class UnitSelectionDialogComponent implements OnInit {
    units: UnitType[] = [];
    unitControl = new FormControl<string[]>([], [Validators.required]);
    saving = false;

    constructor(
        private _dialogRef: MatDialogRef<UnitSelectionDialogComponent>,
        private _sharedService: SharedService,
        private _keycloakService: KeycloakService,
    ) {}

    ngOnInit(): void {
        this._sharedService.getEntities<UnitType>(Endpoint.UNIT).pipe(take(1)).subscribe({
            next: (units) => { this.units = units; },
        });
    }

    save(): void {
        if (this.unitControl.invalid) return;
        this.saving = true;

        this._sharedService.simplePutEntity<void>(
            `user/${this._keycloakService.getKeycloakInstance().subject}/unit-ids`,
            { unitIds: this.unitControl.value },
        )
            .pipe(take(1))
            .subscribe({
                next: () => this._dialogRef.close(true),
                error: () => { this.saving = false; },
            });
    }
}
